export { tweakwiseTracker } from '../../../../../../vendor/happy-horizon/tweakwise-core/resources/resources/assets/js/tweakwise';
